import { PersistConfig, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { EMobilityAction, EMobilityActionType, EMobilityState } from './EMobilityStateModel'
import { MetricType } from '../../Libs/e-mobility/dashboard/models/dashboard.model'

export const initialState: EMobilityState = {
  dashboard: {
    metric: MetricType.Energy,
  },
  chargingSessionsFilters: {
    filters: {
      wallboxIds: [],
      statuses: [],
      ocpiTokenIds: [],
      midMeter: [],
      startDate: '',
      endDate: '',
      limit: 10,
      page: 0,
      sort: { direction: 'desc', name: 'startDateTime' },
    },
  },
  chargingCardsTable: { sort: { direction: 'asc', name: 'tokenId' } },
  tariffsTable: { sort: undefined },
  tour: {
    isRunning: false,
    isCompleted: false,
  },
  chargingCardsMobileSort: { sort: { direction: 'asc', name: 'tokenId' } },
  tariffsMobileSort: { sort: undefined },
}

const eMobilityReducer = (state: EMobilityState = initialState, action: EMobilityAction): EMobilityState => {
  switch (action.type) {
    case EMobilityActionType.SetChargingCardsSort:
      return { ...state, chargingCardsTable: { sort: action.payload } }

    case EMobilityActionType.SetChargingSessionsFilters:
      return {
        ...state,
        chargingSessionsFilters: {
          ...state.chargingSessionsFilters,
          filters: action.payload ?? state.chargingSessionsFilters.filters,
        },
      }

    case EMobilityActionType.SetTariffsSort:
      return { ...state, tariffsTable: { sort: action.payload } }

    case EMobilityActionType.SetTourRunning:
      return { ...state, tour: { ...state.tour, isRunning: action.payload } }

    case EMobilityActionType.SetTourCompleted:
      return { ...state, tour: { ...state.tour, isCompleted: action.payload } }

    case EMobilityActionType.SetDashboardMetric:
      return { ...state, dashboard: { ...state.dashboard, metric: action.payload } }

    case EMobilityActionType.SetChargingCardsMobileSort:
      return { ...state, chargingCardsMobileSort: { ...state.chargingCardsMobileSort, sort: action.payload } }

    case EMobilityActionType.SetTariffsMobileSort:
      return { ...state, tariffsMobileSort: { ...state.tariffsMobileSort, sort: action.payload } }

    default:
      return state
  }
}

const persistConfig: PersistConfig & { whitelist: (keyof EMobilityState)[] } = {
  key: 'eMobility',
  storage,
  whitelist: ['dashboard'],
}

export default persistReducer(persistConfig, eMobilityReducer)
